export default __webpack_public_path__ + "static/media/ch.f437c14d.svg";